import BannerAtendimentoService from '../services/banner.atendimento.service';

export const bannerAtendimento = {
  namespaced: true,
  actions: {
    get({ commit }) {
      return BannerAtendimentoService.get();
      // return BannerHomeService.get().then(
      //   resp => {
      //     return Promise.resolve(resp);
      //   },
      //   error => {
      //     return Promise.reject(error);
      //   }
      // );
    }
  },
  mutations: {
    }
};
